<glxy-page-wrapper [ngClass]="{ 'table-view': listOrTableView() === 'table' }">
  @if (listOrTableView() === 'list' && !recordingsUpgradeRequired()) {
    <div class="header-controls">
      <glxy-form-field [suffixIcon]="'search'">
        <input
          matInput
          [placeholder]="'COMMON.SEARCH' | translate"
          [(ngModel)]="searchTerm"
          data-action="used-recordings-search"
        />
      </glxy-form-field>
      <ng-container *ngTemplateOutlet="upcomingPastToggle"></ng-container>
      <ng-container *ngTemplateOutlet="listOrTableToggle"></ng-container>
    </div>
  }

  @if (loading()) {
    <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
  } @else if (recordingsUpgradeRequired()) {
    <meeting-analysis-recordings-upgrade></meeting-analysis-recordings-upgrade>
  } @else {
    @if (listOrTableView() === 'list') {
      @if (upcomingOrPast() === 'past') {
        @if (conversationsByDate$ | async; as conversationsByDate) {
          @if (conversationsByDate.size > 0) {
            @for (conversationByDate of conversationsByDate | keyvalue: dateDesc; track conversationByDate.key) {
              <mat-accordion>
                <div class="date">{{ conversationByDate.key | date: 'MMMM d, yyyy' }}</div>
                @for (conversation of $any(conversationByDate.value); track conversation.id) {
                  <meeting-analysis-meeting-list-item
                    [conversation]="conversation"
                  ></meeting-analysis-meeting-list-item>
                }
              </mat-accordion>
            }
            <glxy-alert
              type="tip"
              [showAction]="true"
              [actionTitle]="'MEETING_LIST.SWITCH_TO_TABLE_VIEW' | translate"
              (actionClick)="listOrTableView.set('table')"
            >
              {{ 'MEETING_LIST.LOOKING_FOR_MORE' | translate }}
            </glxy-alert>
          } @else {
            @if (searchTerm()) {
              <glxy-empty-state [size]="'small'">
                <glxy-empty-state-hero>
                  <mat-icon>search_off</mat-icon>
                </glxy-empty-state-hero>
                <glxy-empty-state-title> {{ 'MEETING_LIST.NO_RESULTS' | translate }}</glxy-empty-state-title>
                <p>{{ 'MEETING_LIST.TABLE_FILTER_NO_RESULT' | translate }}</p>
              </glxy-empty-state>
            } @else {
              <glxy-empty-state>
                <glxy-empty-state-hero>
                  <img
                    src="https://vstatic-prod.apigateway.co/partner-center-client.9223372035079621779.prod/assets/recordings_empty.png"
                    alt="No recordings"
                  />
                </glxy-empty-state-hero>
                <glxy-empty-state-title>
                  {{ 'MEETING_ANALYSIS.EMPTY_STATE.PAST_TITLE' | translate }}</glxy-empty-state-title
                >
                <p>{{ 'MEETING_ANALYSIS.EMPTY_STATE.PAST_DESCRIPTION' | translate }}</p>
              </glxy-empty-state>
            }
          }
        }
      } @else if (upcomingOrPast() === 'upcoming') {
        @if (upcomingMeetingsByDate$ | async; as upcomingMeetingsByDate) {
          @if (upcomingMeetingsByDate.size > 0) {
            @for (
              upcomingMeetingByDate of upcomingMeetingsByDate | keyvalue: dateAsc;
              track upcomingMeetingByDate.key
            ) {
              <mat-accordion>
                <div class="date">{{ upcomingMeetingByDate.key | date: 'MMMM d, yyyy' }}</div>
                @for (meetingBot of $any(upcomingMeetingByDate.value); track meetingBot.id) {
                  <meeting-analysis-meeting-bot-list-item
                    [meetingBot]="meetingBot"
                  ></meeting-analysis-meeting-bot-list-item>
                }
              </mat-accordion>
            }
            <glxy-alert
              type="tip"
              [showAction]="true"
              [actionTitle]="'MEETING_LIST.SWITCH_TO_TABLE_VIEW' | translate"
              (actionClick)="listOrTableView.set('table')"
            >
              {{ 'MEETING_LIST.LOOKING_FOR_MORE' | translate }}
            </glxy-alert>
          } @else {
            @if (searchTerm()) {
              <glxy-empty-state [size]="'small'">
                <glxy-empty-state-hero>
                  <mat-icon>search_off</mat-icon>
                </glxy-empty-state-hero>
                <glxy-empty-state-title> {{ 'MEETING_LIST.NO_RESULTS' | translate }}</glxy-empty-state-title>
                <p>{{ 'MEETING_LIST.TABLE_FILTER_NO_RESULT' | translate }}</p>
              </glxy-empty-state>
            } @else {
              <glxy-empty-state>
                <glxy-empty-state-hero>
                  <img
                    src="https://vstatic-prod.apigateway.co/partner-center-client.9223372035079621779.prod/assets/recordings_empty.png"
                    alt="No upcoming recordings"
                  />
                </glxy-empty-state-hero>
                <glxy-empty-state-title>
                  {{ 'MEETING_ANALYSIS.EMPTY_STATE.UPCOMING_TITLE' | translate }}</glxy-empty-state-title
                >
                <p>{{ 'MEETING_ANALYSIS.EMPTY_STATE.UPCOMING_DESCRIPTION' | translate }}</p>
              </glxy-empty-state>
            }
          }
        }
      }
    } @else if (listOrTableView() === 'table') {
      @if (upcomingOrPast() === 'past') {
        <glxy-table-container
          class="recordings-table-container"
          [dataSource]="dataSource"
          [pageSizeOptions]="[25, 50, 100]"
          [pageSize]="25"
          [columns]="pastRecordingsTableColumns"
          [fullWidth]="true"
          [border]="true"
        >
          <glxy-table-content-header
            [showSearch]="true"
            [showFilters]="true"
            [showSort]="false"
            [showFiltersOpen]="false"
          >
            <div filters-area class="filters-section">
              <glxy-filter-chips (filtersChanged)="onFilterChanged($event)" />
            </div>
            <div after-search class="table-controls">
              <ng-container *ngTemplateOutlet="upcomingPastToggle"></ng-container>
              <ng-container *ngTemplateOutlet="listOrTableToggle"></ng-container>
            </div>
          </glxy-table-content-header>

          <table mat-table>
            <tr mat-header-row *matHeaderRowDef="[]"></tr>
            <tr mat-row *matRowDef="let row; columns: []"></tr>

            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_LIST.TABLE.COLUMNS.TITLE' | translate }}</th>
              <td mat-cell *matCellDef="let element">
                <a
                  class="meeting-title-link"
                  [routerLink]="
                    routeService.applyRoutePrefix(element.meetingDate | conversationPagePath: element.id) | async
                  "
                  data-action="clicked-meeting-title"
                >
                  {{ element.title }}
                </a>
              </td>
            </ng-container>

            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_LIST.TABLE.COLUMNS.DATE' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.date }}</td>
            </ng-container>

            <ng-container matColumnDef="startTime">
              <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_LIST.TABLE.COLUMNS.START_TIME' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.startTime }}</td>
            </ng-container>

            <ng-container matColumnDef="duration">
              <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_LIST.TABLE.COLUMNS.DURATION' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.duration }}</td>
            </ng-container>

            <ng-container matColumnDef="guestCount">
              <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_LIST.TABLE.COLUMNS.GUESTS' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.guestCount }}</td>
            </ng-container>

            <ng-container matColumnDef="privacyLevel">
              <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_LIST.TABLE.COLUMNS.VISIBILITY' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="visibility-cell">
                @let privacyInfo = getPrivacyLevelInfo(element.privacyLevel, namespaceName$ | async);
                <mat-icon [glxyTooltip]="privacyInfo.tooltip">
                  {{ privacyInfo.icon }}
                </mat-icon>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editVisibility(element)">
                    <span>{{ 'MEETING_LIST.TABLE.EDIT_VISIBILITY' | translate }}</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
          </table>

          @if ((dataSource.dataMembers$ | async)?.length === 0 && (dataSource.loading$ | async) === false) {
            <glxy-empty-state [size]="'small'" class="table-empty-state">
              <glxy-empty-state-hero>
                <mat-icon>search_off</mat-icon>
              </glxy-empty-state-hero>
              <glxy-empty-state-title>{{ 'MEETING_LIST.NO_RESULTS' | translate }}</glxy-empty-state-title>
            </glxy-empty-state>
          }
        </glxy-table-container>
      } @else if (upcomingOrPast() === 'upcoming') {
        <glxy-table-container
          class="recordings-table-container"
          [dataSource]="upcomingDataSource"
          [pageSizeOptions]="[25, 50, 100]"
          [pageSize]="25"
          [columns]="upcomingTableColumns"
          [fullWidth]="true"
          [border]="true"
        >
          <glxy-table-content-header
            [showSearch]="true"
            [showFilters]="false"
            [showSort]="false"
            [showFiltersOpen]="false"
          >
            <div filters-area class="filters-section">
              <glxy-filter-chips (filtersChanged)="onFilterChanged($event)" />
            </div>
            <div after-search class="table-controls">
              <ng-container *ngTemplateOutlet="upcomingPastToggle"></ng-container>
              <ng-container *ngTemplateOutlet="listOrTableToggle"></ng-container>
            </div>
          </glxy-table-content-header>
          <table mat-table>
            <tr mat-header-row *matHeaderRowDef="[]"></tr>
            <tr mat-row *matRowDef="let row; columns: []"></tr>

            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_LIST.TABLE.COLUMNS.TITLE' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.title }}</td>
            </ng-container>

            <ng-container matColumnDef="url">
              <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_LIST.TABLE.COLUMNS.URL' | translate }}</th>
              <td mat-cell *matCellDef="let element">
                <a class="meeting-url-link" [href]="element.url" target="_blank">{{ element.url }}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_LIST.TABLE.COLUMNS.DATE' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="no-wrap-cell">{{ element.date }}</td>
            </ng-container>

            <ng-container matColumnDef="startTime">
              <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_LIST.TABLE.COLUMNS.START_TIME' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="no-wrap-cell">{{ element.startTime }}</td>
            </ng-container>

            <ng-container matColumnDef="guestCount">
              <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_LIST.TABLE.COLUMNS.GUESTS' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.guestCount }}</td>
            </ng-container>

            <ng-container matColumnDef="privacyLevel">
              <th mat-header-cell *matHeaderCellDef>
                <div class="header-with-tooltip">
                  <span class="visibility-cell-text">{{ 'MEETING_LIST.TABLE.COLUMNS.VISIBILITY' | translate }}</span>
                  <mat-icon class="tooltip-icon" (click)="openVisibilityInfoDialog()">info_outline</mat-icon>
                </div>
              </th>
              <td mat-cell *matCellDef="let element" class="visibility-cell" class="no-wrap-cell">
                @if (element.privacyLevel === privacyLevel.PRIVACY_LEVEL_PRIVATE) {
                  <span>{{ 'RECORDING_VISIBILITY.OVERRIDE' | translate }}</span>
                } @else {
                  <span>{{ 'RECORDING_VISIBILITY.DEFAULT' | translate }}</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="overrideMeetingBotPrivacyDialog(element)">
                    <span>{{ 'MEETING_LIST.TABLE.EDIT_VISIBILITY' | translate }}</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
          </table>
          @if (
            (upcomingDataSource.dataMembers$ | async)?.length === 0 && (upcomingDataSource.loading$ | async) === false
          ) {
            <glxy-empty-state [size]="'small'" class="table-empty-state">
              <glxy-empty-state-hero>
                <mat-icon>search_off</mat-icon>
              </glxy-empty-state-hero>
              <glxy-empty-state-title>{{ 'MEETING_LIST.NO_RESULTS' | translate }}</glxy-empty-state-title>
            </glxy-empty-state>
          }
        </glxy-table-container>
      }
    }
  }
</glxy-page-wrapper>

<ng-template #loadingTemplate>
  <div class="loading-container">
    <mat-spinner [diameter]="60" [strokeWidth]="2" [color]="'primary'"></mat-spinner>
  </div>
</ng-template>

<ng-template #upcomingPastToggle>
  <mat-button-toggle-group [(ngModel)]="upcomingOrPast">
    <mat-button-toggle value="upcoming" data-action="clicked-upcoming-recordings"
      >{{ 'COMMON.UPCOMING' | translate }}
    </mat-button-toggle>
    <mat-button-toggle value="past" data-action="clicked-past-recordings"
      >{{ 'COMMON.PAST' | translate }}
    </mat-button-toggle>
  </mat-button-toggle-group>
</ng-template>

<ng-template #listOrTableToggle>
  <mat-button-toggle-group [(ngModel)]="listOrTableView" (change)="viewTypeToggled()">
    <mat-button-toggle value="list" data-action="clicked-list-view">
      <mat-icon>grid_view</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="table" data-action="clicked-table-view">
      <mat-icon>list</mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>
</ng-template>
